import apiClient from './apiClient';
import { offlineStorage } from './offlineStorage';

// Code Generation
export const generateDocumentCode = async () => {
  const response = await apiClient.post('/codes/generate-document-code');
  return response.data;
};

export const generateBundleCode = async () => {
  const response = await apiClient.post('/codes/generate-bundle-code');
  return response.data;
};

// Bulk Code Generation
export const generateDocumentCodesBulk = async (quantity) => {
  const response = await apiClient.post(`/codes/generate-document-codes-bulk?quantity=${quantity}`);
  return response.data;
};

export const generateBundleCodesBulk = async (quantity) => {
  const response = await apiClient.post(`/codes/generate-bundle-codes-bulk?quantity=${quantity}`);
  return response.data;
};

export const validateDocumentCode = async (code) => {
  // Check if online
  if (!navigator.onLine) {
    // Offline: Check IndexedDB
    try {
      const exists = await offlineStorage.checkDocumentCodeExists(code);
      if (exists) {
        return { valid: false, message: 'Document code already exists (offline check)' };
      }
      return { valid: true };
    } catch (error) {
      console.error('Offline validation error:', error);
      return { valid: true }; // Allow if offline check fails
    }
  }
  
  // Online: Check server
  try {
    const response = await apiClient.post(`/codes/validate-document-code?code=${code}`);
    return response.data;
  } catch (error) {
    // If network error, fallback to offline check
    if (error.code === 'ERR_NETWORK' || error.message.includes('Network Error')) {
      const exists = await offlineStorage.checkDocumentCodeExists(code);
      if (exists) {
        return { valid: false, message: 'Document code already exists (offline check)' };
      }
      return { valid: true };
    }
    throw error;
  }
};

export const validateBundleCode = async (code) => {
  // Check if online
  if (!navigator.onLine) {
    // Offline: Check IndexedDB
    try {
      const exists = await offlineStorage.checkBundleCodeExists(code);
      if (exists) {
        return { valid: false, message: 'Bundle code already exists (offline check)' };
      }
      return { valid: true };
    } catch (error) {
      console.error('Offline validation error:', error);
      return { valid: true }; // Allow if offline check fails
    }
  }
  
  // Online: Check server
  try {
    const response = await apiClient.post(`/codes/validate-bundle-code?code=${code}`);
    return response.data;
  } catch (error) {
    // If network error, fallback to offline check
    if (error.code === 'ERR_NETWORK' || error.message.includes('Network Error')) {
      const exists = await offlineStorage.checkBundleCodeExists(code);
      if (exists) {
        return { valid: false, message: 'Bundle code already exists (offline check)' };
      }
      return { valid: true };
    }
    throw error;
  }
};

// Inward Entries
export const uploadImages = async (files) => {
  const formData = new FormData();
  files.forEach(file => {
    formData.append('files', file);
  });
  
  const response = await apiClient.post('/inward/upload-images', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const createInwardEntry = async (entryData) => {
  const response = await apiClient.post('/inward/entries', entryData);
  return response.data;
};

export const submitDraftEntry = async (entryId) => {
  const response = await apiClient.put(`/inward/entries/${entryId}/submit`);
  return response.data;
};

export const updateInwardEntry = async (entryId, updateData) => {
  const response = await apiClient.put(`/inward/entries/${entryId}`, updateData);
  return response.data;
};

export const getInwardEntries = async (skip = 0, limit = 100) => {
  const response = await apiClient.get(`/inward/entries?skip=${skip}&limit=${limit}`);
  return response.data;
};

export const getInwardEntry = async (entryId) => {
  const response = await apiClient.get(`/inward/entries/${entryId}`);
  return response.data;
};

export const deleteBundleFromEntry = async (entryId, bundleBarcode) => {
  const response = await apiClient.delete(`/inward/entries/${entryId}/bundles/${bundleBarcode}`);
  return response.data;
};

export const deleteInwardEntry = async (entryId) => {
  const response = await apiClient.delete(`/inward/entries/${entryId}`);
  return response.data;
};
